/**
* DevExpress Dashboard (_card.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { parseBool } from '../../../metadata/_base-metadata';
import { kpiElementSerializationsInfo } from '../../kpi/metadata/_kpi-element';
import { CardDeltaOptions } from '../../options/delta-options';
import { SparklineOptions } from '../../options/sparkline-options';
export let cardDeltaOptions = { propertyName: 'cardDeltaOptions', modelName: 'CardDeltaOptions', displayName: 'DashboardWebStringId.Grid.DeltaOptions', type: CardDeltaOptions };
export let cardSparklineOptions = { propertyName: 'sparklineOptions', modelName: 'SparklineOptions', displayName: 'DashboardWebStringId.Card.SparklineOptions', type: SparklineOptions };
export let showSparkline = { propertyName: 'showSparkline', modelName: '@ShowStartEndValues', displayName: 'DashboardWebStringId.Card.SparklineVisible', defaultVal: true, simpleFormAdapterItem: 'yesNoButtonGroupEditor', from: parseBool };
export let layoutTemplate = { propertyName: 'layoutTemplate', modelName: 'LayoutTemplate' };
export let cardSerializationsInfo = kpiElementSerializationsInfo.concat([cardDeltaOptions, cardSparklineOptions, showSparkline, layoutTemplate]);
